import { QueryHookOptions, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  SearchForTasks as SearchForTasksResponseGenerated,
  SearchForTasks_searchWithMetadata_items as SearchForTasksSearchWithMetadataItemsGenerated,
  SearchForTasksVariables as SearchForTasksVariablesGenerated,
} from "core/queries/__generated__/SearchForTasks";

export interface SearchForTasksVariables
  extends SearchForTasksVariablesGenerated {}
export interface SearchForTasksResponse
  extends SearchForTasksResponseGenerated {}

export interface SearchForTasksItem
  extends SearchForTasksSearchWithMetadataItemsGenerated {}

export enum SearchForTasksItemResourceType {
  Inquiry = "Inquiry",
  LeaseInquiry = "LeaseInquiry",
  Task = "Task",
  Unit = "Unit",
}

const searchForTasks = gql`
  query SearchForTasks(
    $searchTerm: String!
    $filters: SearchFilterInput
    $pagination: Pagination
    $sorting: Sorting
  ) {
    searchWithMetadata(
      searchTerm: $searchTerm
      resultType: task
      filters: $filters
      pagination: $pagination
      sorting: $sorting
    ) {
      total
      cursor
      hasMore
      items {
        id
        title
        subtitle
        description
        resource {
          ... on Building {
            buildingId: id
          }
          ... on CufSpace {
            id
          }
          ... on City {
            cityId: id
          }
          ... on Unit {
            id
          }
          ... on User {
            id
          }
          ... on Inquiry {
            id
          }
          ... on LeaseInquiry {
            id
          }
          ... on Task {
            type
            id
            priority
            status
            dueAt
            createdAt
            assignee {
              id
              name
              avatar: profilePicture {
                id
                url
              }
            }
          }
          ... on TaskContext {
            id
          }
          ... on TaskTypeConfiguration {
            id
          }
          ... on TomBooking {
            id
          }
        }
      }
    }
  }
`;

export const useSearchForTasks = (
  options: QueryHookOptions<SearchForTasksResponse, SearchForTasksVariables>,
) => {
  return useQuery<SearchForTasksResponse, SearchForTasksVariables>(
    searchForTasks,
    options,
  );
};
